import { MenuItem } from "@mui/material";
import { Opportunity } from "generated/graphql";
import { Link } from "react-router-dom";

export default function UpdateOpportunityMenuItem(props: BitumioMenuItem<Opportunity>) {
  const { object, closeMenu } = props;

  return (
    <MenuItem component={Link} onClick={closeMenu} to={`/opportunities/${object.id}/update`}>
      Update
    </MenuItem>
  );
}
